<template>
  <div
    :class="classes"
    data-testid="option"
    @click="handleClick"
    @mouseenter="emit('mouseenter', $event)"
    @mouseleave="emit('mouseleave', $event)"
  >
    <div v-if="icon">
      <BaseIcon
        class="tw:text-lg"
        :icon="icon"
        :icon-class="localIconClass"
      />
    </div>

    <slot>
      <div>
        {{ label }}
      </div>
    </slot>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface AIAssistantBaseOption {
  disabled?: boolean;
  icon?: string;
  iconClass?: string;
  quickAccess?: boolean;
  label?: string;
  product?: AIAssistantOption["product"];
}

import BaseIcon from "shared/components/base/BaseIcon.vue";
import { type AIAssistantOption } from "shared/composables/useAIAssistantOptions";

const props = defineProps<AIAssistantBaseOption>();

const emit = defineEmits(["click", "mouseenter", "mouseleave"]);

const classes = computed(() => {
  const localClasses = [
    "tw:border-denim-200",
    "tw:border-solid",
    "tw:border",
    "tw:flex",
    "tw:gap-2",
    "tw:hover:bg-denim-100",
    "tw:items-center",
    "tw:p-2",
    "tw:rounded-lg",
  ];

  if (props.disabled) {
    localClasses.push("tw:cursor-not-allowed", "tw-opacity-50");
  } else {
    localClasses.push("tw:cursor-pointer");
  }

  return localClasses;
});

const localIconClass = computed(() => {
  if (props.iconClass) return props.iconClass;
  if (props.product === "monitoring") return "tw:text-blue-700";
  if (props.product === "social") return "tw:text-purple-500";
  if (props.product === "outreach") return "tw:text-blue-700";

  return "";
});

function handleClick() {
  if (props.disabled) return;
  emit("click");
}
</script>
